<template>
  <div class="vx-row w-full p-4">
    <!-- Section: List of Evaluations -->
    <div class="vx-col sm:w-2/3 w-full mb-6 relative">
      <vx-card class="h-full clean-card" :title="null">
        <div class="card-header pb-4 border-b border-gray-100 flex items-center justify-between">
          <div>
            <h3 class="text-xl font-bold text-gray-800">Evaluaciones Resueltas</h3>
            <p class="text-gray-500 text-sm mt-1">Historial de evaluaciones finalizadas</p>
          </div>
          <div class="p-2 bg-gray-50 rounded-lg text-gray-500">
            <i class="feather icon-list text-xl"></i>
          </div>
        </div>

        <div class="mt-4">
          <vs-table max-items="20" search pagination :data="listaEvaluaciones" noDataText="No hay evaluaciones disponibles">
            <template slot="header">
              <!-- Empty header slot effectively removes the default search bar container styling issues if any, search prop handles the input -->
            </template>
            <template slot-scope="{data}">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data" class="styled-row">
                <vs-td>
                  <div class="flex items-center py-2">
                    <div class="w-10 h-10 rounded-full bg-blue-50 flex items-center justify-center text-blue-600 mr-3">
                      <i class="feather icon-file-text"></i>
                    </div>
                    <div class="text-sm">
                      <p v-for="(item,key) in arregloPeriodos" :key="key" class="m-0">
                        <span v-if="item.id == periodoSelect" class="text-gray-700 font-medium">
                          Periodo Evaluación <span class="mx-1 text-gray-400">|</span> <b class="text-gray-900">{{ item.nombre }}</b>
                        </span>
                      </p>
                      <span class="text-xs text-gray-400">Evaluación completada</span>
                    </div>
                  </div>
                </vs-td>
                <vs-td class="text-right whitespace-no-wrap">
                  <vs-button
                    :disabled="ver_respuestas_activo"
                    color="primary"
                    type="border"
                    size="small"
                    icon-pack="feather"
                    icon="icon-eye"
                    class="action-btn"
                    @click="revisarEvaluacion(data[indextr].id_evaluacion)"
                  >
                    Revisar
                  </vs-button>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>

          <div v-if="ver_respuestas_activo===true" class="mt-4 flex items-center p-3 mb-2 text-sm text-yellow-800 border border-yellow-200 rounded-lg bg-yellow-50" role="alert">
             <i class="feather icon-info mr-2 text-lg"></i>
             <span class="font-medium">La revisión de preguntas no está activada para su institución</span>
          </div>
        </div>
      </vx-card>
    </div>

    <!-- Section: Actions & Status -->
    <div class="vx-col sm:w-1/3 w-full mb-6">
      <vx-card class="h-full clean-card text-center relative overflow-hidden" :title="null">
        <div class="card-header mb-6">
          <h3 class="text-xl font-bold text-gray-800">Panel de Control</h3>
          <p class="text-gray-500 text-sm mt-1">Acciones rápidas</p>
        </div>

        <div id="div-with-loading" class="vs-con-loading__container py-4 min-h-[140px] flex flex-col justify-center items-center">
            <div v-if="evaluacionOk===true" class="w-full fade-in">
                <div class="w-20 h-20 bg-green-50 text-green-500 rounded-full flex items-center justify-center mx-auto mb-4 shadow-sm">
                   <i class="feather icon-check-circle text-4xl"></i>
                </div>
                <h4 class="text-lg font-semibold text-gray-800 mb-4">Evaluación Disponible</h4>
                <vs-button class="w-full shadow-lg hover:shadow-xl transition-transform transform hover:-translate-y-1" color="#28C76F" size="large" icon-pack="feather" icon="icon-play-circle" @click="resolverEvaluacion()">
                    Resolver Evaluación
                </vs-button>
            </div>
            <div v-else class="w-full fade-in">
                 <div class="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4 shadow-inner" :style="`background-color: ${eval_color}15; color: ${eval_color}`">
                  <i class="feather icon-check text-3xl"></i>
                </div>
                <div class="bg-gray-50 rounded-lg p-4 border border-gray-100">
                   <b class="block mb-1" :style="`color: ${eval_color}`">Evaluación realizada</b>
                   <p class="text-sm text-gray-600 leading-snug">{{mensajeEvaluacion}}</p>
                </div>
            </div>
        </div>

        <div class="w-full border-t border-gray-100 my-6"></div>

        <div class="w-full">
            <vs-button class="w-full action-btn-secondary" color="warning" type="flat" icon-pack="feather" icon="icon-grid" @click="asignaturasUsuario()">
                Mis Asignaturas
            </vs-button>
        </div>
      </vx-card>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import vSelect from 'vue-select'
import moment from 'moment'
export default {
    data() {
      return {
        usuario: [],
        listaEvaluaciones: [],
        asignaturasDocente: 0,
        configuracion: [],
        fechaLocal: '',
        evaluacionOk: false,
        mensajeEvaluacion: '',
        eval_color: '#2196f3',
        ver_respuestas_activo: false,
        arregloPeriodos:[],
      }
    },
    components: {
      'v-select': vSelect,
    },
    async created() {
      this.usuario = JSON.parse(localStorage.getItem('usuario'));
    },
    mounted() {
      let me = this;
      me.getPeriodosEvaluacion()
      me.verificarAsginaturasDocente();
    },
    methods: {
      getPeriodosEvaluacion() {
        let me = this;
        this.$http.get(this.$server_url+'salle/periodos')
          .then(function (response) {
            me.arregloPeriodos = response.data;
            let getEvaluacionSelect = localStorage.EvaluacionSelectSalle
            //si ya existe el periodo seleccionado lo asigno
            if(getEvaluacionSelect){
              me.periodoSelect = parseInt(getEvaluacionSelect)
              return
            }
            if(me.arregloPeriodos.length > 0){
              me.periodoSelect = me.arregloPeriodos[0].id
            }
          })
          .catch(function (error) {
          })
      },
      verificarAsginaturasDocente() {
        let me = this;
        this.$http.get(this.$server_url+'asignaturas_docente_salle/' + me.usuario.idusuario+'/'+localStorage.EvaluacionSelectSalle)
          .then(res => {
            me.asignaturasDocente = res.data.asignaturas.length
          })
          .catch(err => {
          })
          me.$vs.loading({
            container: '#div-with-loading',
            scale: 1,
            type:'material',
          });
        this.$http.get(this.$server_url+'institucionConfiguracionSalle/' + me.usuario.institucion_idInstitucion+'/'+localStorage.EvaluacionSelectSalle)
          .then(res => {
            me.$vs.loading.close();
            me.configuracion = res.data;
            if( me.configuracion[0].ver_respuestas == 0 ){
              me.ver_respuestas_activo = true
            }
            me.getEvaluacionesResueltas()
          })
          .catch(err => {
            console.log(err)
            me.$vs.loading.close('#div-with-loading > .con-vs-loading');
          })
      },
      asignaturasUsuario() {
        let me = this;
        me.$router.push('/docente/usuarioasignaturas');
      },
      verPromedios(item) {
        let me = this;
        if (me.configuracion[0].ver_respuestas == 0) {
          me.$vs.notify({
            text: 'Los resultados aún no estan disponibles, un administrador de La Salle, lo habilitará más adelante.',
            color: 'warning',
            iconPack: 'feather',
            icon: 'icon-alert-triangle'
          })
          return
        }
      },
      resolverEvaluacion() {
        let me = this;
        localStorage.setItem('tipo_revisar', 0);
        me.$router.push('/salle/docente/evaluacion');
      },
      revisarEvaluacion(id_evaluacion) {
        let me = this;
        localStorage.setItem('tipo_revisar', 1);
        localStorage.setItem('id_evaluacion_salle', id_evaluacion);
        me.$router.push('/salle/docente/evaluacion');
      },
      async getEvaluacionesResueltas(){
        let me = this
        me.$vs.loading();
        await me.$http.get(this.$server_url+'evaluaciones_resueltas_salle/' + me.usuario.idusuario+'/'+localStorage.EvaluacionSelectSalle)
        .then(res => {
          me.$vs.loading.close();
          me.listaEvaluaciones = res.data
          let date_actua = new Date()
          me.fechaLocal = moment(date_actua, 'DD/MM/YYYY HH:mm:ss').format('YYYY-MM-DD HH:mm:ss');
          if (me.configuracion !== undefined && me.configuracion.length > 0) {
            if (me.fechaLocal > me.configuracion[0].fecha_inicio && me.fechaLocal < me.configuracion[0].fecha_fin ) {
              // se valida que no permita dar mas evaluaciones de las permitidas en la configuracion, teniendo el cuenta el periodo.
              var evaluaciones_periodo_actual = 0
              var d = new Date();
              var anio_actual = d.getFullYear();
              $.each(me.listaEvaluaciones, function(key, value){
                  console.log((((value.updated_at).split(' '))[0]).split('-')[0] +' == '+ anio_actual)
                  if( (((value.updated_at).split(' '))[0]).split('-')[0] == anio_actual ){
                      evaluaciones_periodo_actual++
                  }
              });
              if( evaluaciones_periodo_actual < me.configuracion[0].cant_evaluaciones ){
                  me.evaluacionOk = true;
                  me.mensajeEvaluacion = 'La evaluación estará disponible hasta el día ' + me.fechaLarga(me.configuracion[0].fecha_fin);
                  me.eval_color = '#4caf50';
              }else{
                  me.evaluacionOk = false
              }
            } else {
              me.evaluacionOk = false
              console.log(me.fechaLocal +' < '+ me.configuracion[0].fecha_inicio)
              if (me.fechaLocal < me.configuracion[0].fecha_inicio) {
                  me.mensajeEvaluacion = 'La próxima evaluación estará activa el día: ' + me.fechaLarga(me.configuracion[0].fecha_inicio);
                  me.eval_color = '#2196f3';
              } else {
                  me.mensajeEvaluacion = 'Horario no permitido para rendir la evaluación.';
                  me.eval_color = '#737893';
              }
            }
          } else {
            me.evaluacionOk = false
            me.mensajeEvaluacion = 'Su institucion no está configurada, comuníquese con el administrador.';
            me.eval_color = '#998159';
          }
          me.$vs.loading.close('#div-with-loading > .con-vs-loading');
        })
        .catch(err => {
            me.$vs.loading.close();
        })
      },

    },
}
</script>

<style scoped>
.clean-card {
  border-radius: 16px;
  box-shadow: 0 4px 25px 0 rgba(0,0,0,0.05);
  border: 1px solid rgba(0,0,0,0.03);
  transition: all 0.3s ease;
  background: white;
}
.clean-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 30px rgba(0,0,0,0.08);
}

/* Row Hover Effect */
.styled-row {
  transition: background-color 0.2s ease;
  border-bottom: 1px solid #f3f4f6;
}
.styled-row:hover {
  background-color: #f9fafb !important;
}
.styled-row:last-child {
  border-bottom: none;
}

/* Button Upgrades */
.action-btn {
  border-radius: 8px;
  font-weight: 600;
  transition: all 0.2s;
}
.action-btn:hover {
  background-color: #e3f2fd;
  color: #1976d2 !important; /* Ensure visibility on hover */
}

/* Secondary Action Button */
.action-btn-secondary {
  border-radius: 12px;
  font-weight: 600;
  background-color: #fff8e1; /* Light Amber/Orange */
  color: #ff9800;
  padding: 12px 0;
  transition: all 0.2s;
  border: 1px solid transparent;
}
.action-btn-secondary:hover {
  background-color: #ffecb3;
  color: #e65100;
  transform: translateY(-1px);
  box-shadow: 0 2px 5px rgba(0,0,0,0.05);
}

/* Animations */
.fade-in {
  animation: fadeIn 0.5s ease-in-out;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(5px); }
  to { opacity: 1; transform: translateY(0); }
}

/* Table Customizations */
::v-deep .vs-table--header {
  border-bottom: 2px solid #f3f4f6;
  padding-bottom: 10px;
}
::v-deep .vs-table--search {
  padding: 0;
  margin-bottom: 1rem;
  max-width: 100%;
}
::v-deep .vs-table--search-input {
  border-radius: 12px;
  border: 1px solid #e2e8f0;
  padding: 10px 15px;
  background-color: #f8fafc;
  transition: all 0.3s;
  width: 100%;
}
::v-deep .vs-table--search-input:focus {
  background-color: #fff;
  border-color: #90cdf4;
  box-shadow: 0 0 0 3px rgba(66, 153, 225, 0.1);
}

/* Loading container tweaks */
#div-with-loading {
    min-height: 200px;
}
</style>
